const groupAttr = "data-change-steps-group"
const contentAttr = "data-change-steps-content"
const nextAttr = "data-change-steps-next"
const prevAttr = "data-change-steps-prev"
const loadAttr = "data-change-steps-load"

function initClickAction({ targetAttr }: { targetAttr: string }) {
  const targetEls = document.querySelectorAll(`[${targetAttr}]`)

  if (!targetEls.length) return

  targetEls.forEach((el) => {
    el.addEventListener("click", (e) => {
      e.preventDefault()
      const group = el.getAttribute(groupAttr) || ""
      const nowEls = document.querySelectorAll(
        `[${groupAttr}="${group}"][${contentAttr}].is-active`
      )
      const step = Number(nowEls[0].getAttribute(contentAttr)) || 1
      const moveStep = targetAttr === nextAttr ? step + 1 : step - 1
      const moveEls = document.querySelectorAll(
        `[${groupAttr}="${group}"][${contentAttr}="${moveStep}"]`
      )

      nowEls.forEach((content) => {
        content.classList.remove("is-active")
      })
      moveEls.forEach((content) => {
        content.classList.add("is-active")
      })
    })
  })
}

function initLoadAction() {
  const targetEls = document.querySelectorAll(`[${loadAttr}]`)
  const params = window.location.search.replace("?","").split("&");
  let param;

  for(var i = 0; i < params.length; i++) {
    if(params[i] === "lineTab") {
      param = "line";
    }
    if (params[i] === "cityTab") {
      param = "city";
    }
  }

  if (!targetEls.length) return

  targetEls.forEach((el) => {
    let step = 1

    const values = el.getAttribute(loadAttr)?.split(",") || []
    const conditionalSteps: { [key: string]: number } = {}

    values.forEach((value) => {
      if (value.includes("=")) {
        const [condition, step] = value.split("=")
        conditionalSteps[condition.replace("#", "")] = Number(step)
      } else {
        step = Number(value)
      }
    })
    const group = el.getAttribute(groupAttr) || ""
    const hash = window.location.hash.replace("#", "")
    let activeStep;
    if (document.querySelectorAll(`[data-force-line-tab="true"],[data-force-city-tab="true"]`).length > 0
          || window.location.pathname.includes("/city/")) {
      activeStep = 2;
    } else {
      activeStep = conditionalSteps[param] || conditionalSteps[hash] || step;
    }
    const nowEls = document.querySelectorAll(
      `[${groupAttr}="${group}"][${contentAttr}]`
    )
    const moveEl = document.querySelectorAll(
      `[${groupAttr}="${group}"][${contentAttr}="${activeStep}"]`
    )
    nowEls.forEach((content) => {
      content.classList.remove("is-active")
    })
    moveEl.forEach((content) => {
      content.classList.add("is-active")
    })
  })
}

export function changeStepsNext() {
  initClickAction({ targetAttr: nextAttr })
}
export function changeStepsPrev() {
  initClickAction({ targetAttr: prevAttr })
}
export function changeStepsLoad() {
  initLoadAction()
  window.addEventListener("popstate", initLoadAction)
}
